import { Component, OnInit, ChangeDetectionStrategy } from "@angular/core";
import { FormGroup } from "@angular/forms";
import { MatDialogRef } from "@angular/material/dialog";
import { ToastType } from "src/app/constants/toast-type";

import { AuthService } from "src/app/services/auth.service";
import { SessionService } from "src/app/services/storage/session.service";
import { ToastService } from "src/app/services/toast.service";


@Component({
    selector: 'mwp-dialog-timeout',
    templateUrl: './timeout.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class DialogTimeoutComponent implements OnInit {
    public isChecked = false;
    public inputForm: FormGroup;
    public inputName: string;
    public jsonPreFix: string;

    countdown: number = 298;
    minutes: number = 4;
    seconds: number = 59;

    private timer!: any;
    private expirationTime!: number;

    constructor(
        private authService: AuthService,
        private sesssionService: SessionService,
        private toastService: ToastService,
        private dialogRef: MatDialogRef<DialogTimeoutComponent>,
    ) { }

    ngOnInit(): void {
        if (!this.sesssionService.session?.isLoggedIn) {
            this.dialogRef.close();
        } else {
            this.startTimer();
        }
    }

    ngOnDestroy(): void {
        if (this.timer) {
            clearInterval(this.timer);
        }
    }

    public buttonClicked(): void {
        if (this.timer) {
            clearInterval(this.timer);
        }

        this.authService.refreshSession().subscribe(() => {
            this.dialogRef.close();
        });
    }

    public close(): void {
        if (this.timer) {
            clearInterval(this.timer);
        }
        this.dialogRef.close();
    }

    formatNumber(value: number): string {
        return value < 10 ? `0${value}` : `${value}`;
    }

    private startTimer(): void {
        this.expirationTime = Date.now() + (this.countdown * 1000);

        this.timer = setInterval(() => {
            const remaining = Math.max(
                0,
                Math.floor((this.expirationTime - Date.now()) / 1000)
            );

            this.minutes = Math.floor(remaining / 60);
            this.seconds = remaining % 60;

            if (remaining <= 0) {
                clearInterval(this.timer);

                this.authService.apiLogout().subscribe();
                this.toastService.buildToastMessage(
                    ToastType.error,
                    'Session Expired',
                    'Your session has expired or you are not authorized to continue. If you wish to resume working, please log in again.'
                );

                this.authService.logout();
                this.dialogRef.close();
            }
        }, 1000);
    }
}